import { render, staticRenderFns } from "./RegulationsViewDownload.vue?vue&type=template&id=627639e4&scoped=true"
import script from "./RegulationsViewDownload.vue?vue&type=script&lang=js"
export * from "./RegulationsViewDownload.vue?vue&type=script&lang=js"
import style0 from "./RegulationsViewDownload.vue?vue&type=style&index=0&id=627639e4&prod&lang=scss&scoped=true"
import style1 from "./RegulationsViewDownload.vue?vue&type=style&index=1&id=627639e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627639e4",
  null
  
)

export default component.exports